import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getCheckItemsForTask, putCheckItemsForTask } from "../../store/actions/AMActions";
import * as queryString from "query-string";
import TaskCheckList from "../../components/CheckItemGroup/TaskCheckList";
import { getAutonomousCheckItemFiles } from "../../store/actions/CheckItemGroupActions";

export default function AutonomousTaskCheckList() {
    const dispatch = useDispatch();
    const [pageLoaded, setPageLoaded] = useState(true);
    let [rows, setRows] = useState([]);
    // File Management
    const [checkItemFiles, setCheckItemFiles] = useState([]);
    const [isDocumentPopupOpen, setIsDocumentPopupOpen] = useState(false);

    // Create use effect for load handler
    const taskId = queryString.parse(window.location.search).id;
    useEffect(() => {
        dispatch(getCheckItemsForTask(taskId));
    }, []);

    const { checkItemsForTask } = useSelector(({ am }) => am);
    const { autonomousCheckItemFiles } = useSelector(({ CheckItemGroup }) => CheckItemGroup);

    useEffect(() => {
        if (checkItemsForTask?.resultObject?.content) {
            var incomingRows = Object.values(checkItemsForTask.resultObject.content);
            incomingRows.forEach((row) => {
                var groupStatu = true;
                row.taskCheckItems.map((item) => {
                    if (item.comment === null) item.comment = "";
                    if (item.comment === "" && item.checked === false) {
                        groupStatu = false;
                    }
                });
                row["statu"] = groupStatu;
            });
            setPageLoaded(true);
            setRows(Object.values(checkItemsForTask.resultObject.content));
        }
    }, [checkItemsForTask]);

    useEffect(() => {
        if (autonomousCheckItemFiles) {
            setCheckItemFiles(autonomousCheckItemFiles);
        }
    }, [autonomousCheckItemFiles]);

    const setRowsFunction = (newRows) => {
        setRows(newRows);
    };

    // Handle Save Action
    const handleSave = () => {
        let data = [];
        rows.forEach((row) => {
            row.taskCheckItems.map((item) => {
                data.push({
                    checkItemId: item.checkItemId,
                    checked: item.checked,
                    comment: item.comment,
                });
            });
        });
        var payload = {
            taskId: taskId,
            data: data,
        };
        dispatch(putCheckItemsForTask(payload));
    };

    const HandleDocumentPopupOpen = (id) => {
        setIsDocumentPopupOpen(true);
        dispatch(getAutonomousCheckItemFiles(id));
    };

    return (
        <TaskCheckList
            rows={rows}
            pageLoaded={pageLoaded}
            handleSave={handleSave}
            setRowsFunction={setRowsFunction}
            HandleDocumentPopupOpen={HandleDocumentPopupOpen}
            isDocumentPopupOpen={isDocumentPopupOpen}
            setIsDocumentPopupOpen={setIsDocumentPopupOpen}
            checkItemFiles={checkItemFiles}
        ></TaskCheckList>
    );
}
